import { render } from "./ReservationDetails.vue?vue&type=template&id=2ed6a06c"
import script from "./ReservationDetails.vue?vue&type=script&lang=js"
export * from "./ReservationDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__